module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"privacy_policy":{"meta_tags":{"description":"Wir freuen uns über Ihr Interesse an CAPinside und darüber, dass Sie unsere Homepage besuchen. An dieser Stelle informieren wir Sie darüber, welche Ihrer personenbezogenen Daten wir bei Ihrem Besuch auf unserer Webseite erfassen und für welche Zwecke diese genutzt werden.","title":"Datenschutzhinweis"}}}}}}')
  delete Component.options._Ctor
}
